/**
 * Mappatura con le natura type
 * ee => escluse (N1)
 * ns => non soggette (N2)
 * ni => non imponibili (N3)
 * es => esenti (N4)
 * rm => regime del margine (N5)
 * al => inversione contabile (N6)
 * as => assolta (N7)
 * vi => per gestire la ventilazione (ma è un dato che conosce già la cassa lo manteniamo solo temi di programmazione e recupero dati dalla cassa, non per la vendita)
 */
export enum ZPrinterVatType {
  Vat = 'vat',
  Ee = 'ee',
  Ns = 'ns',
  Ni = 'ni',
  Es = 'es',
  Rm = 'rm',
  Al = 'al',
  As = 'as',
  Vi = 'vi',
}
